export default __webpack_public_path__ + "static/media/woman-mixed-ingredients-kitchen-mixer-bowl-homemade-cooking_77190-7439@2x.91d9c1b8.png";